module.exports = "/_next/static/images/CartAbandonmentMobile-03425f2742d0fbc99f2030ab836737c2.png";